import { useState, useContext } from 'react'
import axios from 'axios'
import { NavigationTabs } from '../../components'
import { Button, Layout, Input } from '../../widgets'
import { adminProjectResolveUrl } from '../../routes'
import { AlertContext } from '../../widgets/AlertContext'
import {
  withRouter,
} from '../../shared'

const AdminProjects = (props) => {
  return <div className='body-container'>
    <Layout>
      <Layout.Header>Projects</Layout.Header>
      <div className='moderator-content'>
        <NavigationTabs
          tabs={{
            'Downloader': <AdminProjectDownloader />,
          }}
        />
      </div>
    </Layout>
  </div>
}

const AdminProjectDownloader = (props) => {
  const { handleError } = useContext(AlertContext)
  const [input, setInput] = useState(null)

  const onDownload = () => {
    axios.post(adminProjectResolveUrl, {
      content: input
    }).then(response => {
      window.open(response.data.archive_url, '_blank')
    }).catch(handleError)
  }

  return <div className='flex-row'>
    <Input
      className='search-input'
      type='text'
      placeholder='Enter a project collaboration link or project snapshot UUID, then press Download'
      onChange={(event) => setInput(event.target.value)}
    />
    <Button className='small' onClick={onDownload}>Download</Button>
  </div>
}

export default withRouter(AdminProjects)
